import { render, staticRenderFns } from "./okTry.vue?vue&type=template&id=079b4fbc&scoped=true&"
import script from "./okTry.vue?vue&type=script&lang=js&"
export * from "./okTry.vue?vue&type=script&lang=js&"
import style0 from "./okTry.vue?vue&type=style&index=0&id=079b4fbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b4fbc",
  null
  
)

export default component.exports